import { useState, useEffect } from "react";
import { Modal, Image, Button, Card } from "antd";
import { CameraOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";


const ImageGallery = ({ images = {} }) => {
    
    const [previewOpen, setPreviewOpen] = useState(false);
    const [currentGroup, setCurrentGroup] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    

    const galleryGroups = Object.entries(images).map(([title, imageArray]) => ({
        title,
        images: imageArray.map((img, index) => ({
            id: img._id || index,
            src: img.url,
            alt: `${title} ${index + 1}`,
        })),
    }));


    const handlePreview = (group, index = 0) => {
        setCurrentGroup(group);
        setCurrentImageIndex(index);
        setPreviewOpen(true);
    };


    const handleNext = () => {
        if (currentGroup && currentImageIndex < currentGroup.images.length - 1) {
            setCurrentImageIndex((prev) => prev + 1);
        }
    };


    const handlePrev = () => {
        if (currentGroup && currentImageIndex > 0) {
            setCurrentImageIndex((prev) => prev - 1);
        }
    };


    const handleClose = () => {
        setPreviewOpen(false);
        setCurrentGroup(null);
        setCurrentImageIndex(0);
    };


    return (
        // <div className="p-4">
        //     <h2 className="text-2xl font-bold mb-6">Gallery</h2>
        //     <Card>
        //         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        //             {galleryGroups.map((group, groupIndex) => (
        //                 <>
        //                     {group.images.length === 0 ? ''
        //                         :
        //                         <div
        //                             key={groupIndex}
        //                             className="w-32 md:w-40 lg:w-48 overflow-hidden rounded shadow-sm hover:shadow-md transition-shadow cursor-pointer bg-white"
        //                             onClick={() => handlePreview(group)}
        //                         >

        //                             <div className="w-full h-24 md:h-28 lg:h-32 relative group ">
        //                                 {group?.images[0] ? (
        //                                     <>
        //                                         <Image
        //                                             preview={false}
        //                                             src={group?.images[0]?.src}
        //                                             alt={group?.images[0]?.alt}
        //                                             className="object-contain"
        //                                             style={{
        //                                                 display: "block",
        //                                                 height: "100%",
        //                                                 width: "100%",
        //                                             }}
        //                                             wrapperClassName="!w-full !h-full"
        //                                         />
        //                                         <div className="absolute inset-0 bg-black/40  opacity-100 transition-all duration-200 flex flex-col justify-between p-2">
        //                                             <div className="text-white text-sm font-medium">
        //                                                 {group?.title}
        //                                             </div>
        //                                             <div className="text-white text-xs">
        //                                                 {group?.images?.length} photos
        //                                             </div>
        //                                         </div>
        //                                     </>
        //                                 ) : (
        //                                     <div className="w-full h-full bg-gray-100 flex items-center justify-center">
        //                                         <CameraOutlined className="text-2xl text-gray-400" />
        //                                     </div>
        //                                     // null
        //                                 )}
        //                             </div>

        //                         </div>
        //                     }
        //                 </>
        //             ))}
        //         </div>
        //     </Card>


        //     <Modal
        //         open={previewOpen}
        //         title={currentGroup?.title}
        //         footer={null}
        //         onCancel={handleClose}
        //         width={600}
        //     // className="max-w-[90vw]"
        //     >
        //         {currentGroup && (
        //             <div className="relative">
        //                 <div className="mt-4 relative group">
        //                     <Image
        //                         preview={false}
        //                         src={currentGroup.images[currentImageIndex].src}
        //                         alt={currentGroup.images[currentImageIndex].alt}
        //                         height={500}
        //                         width={550}
        //                         className="object-contain"
        //                     // className="w-full"
        //                     />


        //                     <div className="absolute inset-y-0 left-0 flex items-center">
        //                         <Button
        //                             type="text"
        //                             icon={<LeftOutlined />}
        //                             onClick={handlePrev}
        //                             disabled={currentImageIndex === 0}
        //                             className="text-white bg-black bg-opacity-50 hover:bg-opacity-75 h-10 ml-2"
        //                         />
        //                     </div>


        //                     <div className="absolute inset-y-0 right-0 flex items-center">
        //                         <Button
        //                             type="text"
        //                             icon={<RightOutlined />}
        //                             onClick={handleNext}
        //                             disabled={
        //                                 currentImageIndex === currentGroup.images.length - 1
        //                             }
        //                             className="text-white bg-black bg-opacity-50 hover:bg-opacity-75 h-10 mr-2"
        //                         />
        //                     </div>
        //                 </div>


        //                 <div className="mt-4 flex justify-center gap-2 overflow-x-auto py-2">
        //                     {currentGroup.images.map((image, index) => (
        //                         <div
        //                             key={image.id}
        //                             onClick={() => setCurrentImageIndex(index)}
        //                             className={`cursor-pointer transition-all duration-200 ${index === currentImageIndex
        //                                 ? "ring-2 ring-blue-500"
        //                                 : "opacity-70 hover:opacity-100"
        //                                 }`}
        //                         >
        //                             <Image
        //                                 preview={false}
        //                                 src={image.src}
        //                                 alt={image.alt}
        //                                 height={100}
        //                                 width={100}
        //                                 className="h-12 w-16 object-contain"
        //                                 style={{ display: "block" }}
        //                             />
        //                         </div>
        //                     ))}
        //                 </div>


        //                 <div className="mt-2 text-center text-gray-500 text-sm">
        //                     Image {currentImageIndex + 1} of {currentGroup.images.length}
        //                 </div>
        //             </div>
        //         )}
        //     </Modal>
        // </div>
        <div className="p-4">
            {galleryGroups[0]?.images?.length !== 0 &&
                <h2 className="text-[20px] font-bold text-[#000000D9] mt-10  mb-4 text-start">
                    Gallery
                </h2>
            }
            <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
                {galleryGroups.map((group, groupIndex) => (
                    <>
                        {group?.images.length === 0 ? ''
                            :
                            <div
                                key={groupIndex}
                                className="relative rounded-lg overflow-hidden group hover:shadow-lg"
                                onClick={() => handlePreview(group)}
                            >

                                <div className="w-full h-24 md:h-28 lg:h-32 relative group ">
                                    {group?.images[0] ? (
                                        <>
                                            <Image
                                                preview={false}
                                                src={group?.images[0]?.src}
                                                alt={group?.images[0]?.alt}
                                                className="object-contain"
                                                style={{
                                                    display: "block",
                                                    height: "100%",
                                                    width: "100%",
                                                }}
                                                wrapperClassName="!w-full !h-full"
                                            />
                                            <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col justify-center items-center ">
                                                <span className="text-white text-[12px] font-normal">
                                                    {group?.title}
                                                </span>
                                                <span className="text-white text-[12px] font-normal">
                                                    ( {group?.images?.length})
                                                </span>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="w-full h-full bg-gray-100 flex items-center justify-center">
                                            <CameraOutlined className="text-2xl text-gray-400" />
                                        </div>
                                        // null
                                    )}
                                </div>

                            </div>
                        }
                    </>
                ))}
            </div>


            <Modal
                open={previewOpen}
                title={currentGroup?.title}
                footer={null}
                onCancel={handleClose}
                width={600}
            // className="max-w-[90vw]"
            >
                {currentGroup && (
                    <div className="relative">
                        <div className="mt-4 relative group">
                            <Image
                                preview={false}
                                src={currentGroup.images[currentImageIndex].src}
                                alt={currentGroup.images[currentImageIndex].alt}
                                height={500}
                                width={550}
                                className="object-contain"
                            // className="w-full"
                            />


                            <div className="absolute inset-y-0 left-0 flex items-center">
                                <Button
                                    type="text"
                                    icon={<LeftOutlined />}
                                    onClick={handlePrev}
                                    disabled={currentImageIndex === 0}
                                    className="text-white bg-black bg-opacity-50 hover:bg-opacity-75 h-10 ml-2"
                                />
                            </div>


                            <div className="absolute inset-y-0 right-0 flex items-center">
                                <Button
                                    type="text"
                                    icon={<RightOutlined />}
                                    onClick={handleNext}
                                    disabled={
                                        currentImageIndex === currentGroup.images.length - 1
                                    }
                                    className="text-white bg-black bg-opacity-50 hover:bg-opacity-75 h-10 mr-2"
                                />
                            </div>
                        </div>


                        <div className="mt-4 flex justify-center gap-2 overflow-x-auto py-2">
                            {currentGroup.images.map((image, index) => (
                                <div
                                    key={image.id}
                                    onClick={() => setCurrentImageIndex(index)}
                                    className={`cursor-pointer transition-all duration-200 ${index === currentImageIndex
                                        ? "ring-2 ring-blue-500"
                                        : "opacity-70 hover:opacity-100"
                                        }`}
                                >
                                    <Image
                                        preview={false}
                                        src={image.src}
                                        alt={image.alt}
                                        height={100}
                                        width={100}
                                        className="h-12 w-16 object-contain"
                                        style={{ display: "block" }}
                                    />
                                </div>
                            ))}
                        </div>


                        <div className="mt-2 text-center text-gray-500 text-sm">
                            Image {currentImageIndex + 1} of {currentGroup.images.length}
                        </div>
                    </div>
                )}
            </Modal>
        </div>
    );
};


export default ImageGallery;